<div class="loader-container d-flex align-items-center justify-content-center">
  <div>
    <app-tgd-loader class="mr-1"></app-tgd-loader>
    Please wait...
  </div>
</div>
